import React from 'react'
import Edit from '../../crud/edit'

const fields = [
  {
    name: 'Embed Code',
    prop: 'value',
    type: 'textarea'
  }
]

const EditSettings = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit MailChimp Public Signup Embed Code'
      fields={fields}
      apiPath='admin/settings/mailchimp_embed_code'
      successRedirectPath='/settings'
      buildMenuItems={() => {}}
      disableDelete
    />
  )
}

export default EditSettings
